<template  >
<div class="content dashboard">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <div class="top_layer">
        <div class="row left">
          <div class="content left-section">
            <loading :mask=true :size="'middle'" :isWhite=true v-if="portStatusLoad"/>
            <div class="col-header status-selection">{{$t('overview.portStatus')}}</div>
            <machine ref="machine"></machine>
            <div class="legend">
                <span v-if="systemHostInfo.SupportPoE" class="power">{{$t('deviceinfo.power')}}</span>
                <div class="link">{{$t('linkUp')}}</div>
                <div class="nolink">{{$t('linkDown')}}</div>
                <div class="icon-tick ft-14 p-b-r5-l10">{{$t('port.enabled')}}</div>
                <div class="icon-btn_close ft-14 p-b-r5-l10">{{$t('port.disabled')}}</div>
            </div>
            <div class="icon-refresh" @click="onRefresh('portstatus')"></div>
          </div>
        </div>
        <div class="row right no-s">
          <div class="content">
            <loading :mask=true :size="'middle'" :isWhite=true v-if="sysInfoLoad || firstSysInfoLoad"/>
            <div class="col-header">{{$t('menu.sysinformation')}}</div>
            <scrollbar ref="scrollbar" class="scrollbar-body">
            <div class="col-body">
              <div class="table-row">
                <div class="title">{{$t('overview.modelname')}}</div>
                <div :title="systemHostInfo.Product" class="value" v-if="systemHostInfo">{{systemHostInfo.Product}}</div>
              </div>
              <div class="table-row">
                <div class="title">{{$t('overview.ipaddress')}} </div>
                <div :title="ipAddressMag" class="value">{{ipAddressMag}}</div>
              </div>
              <div class="table-row">
                <div class="title">{{$t('overview.macaddress')}} </div>
                <div :title="sysBoard.MacAddr" class="value" v-if="sysBoard">{{sysBoard.MacAddr}}</div>
              </div>
              <div class="table-row">
                <div class="title">{{$t('overview.switchFw')}} </div>
                <div :title="fwinfo.version+'.'+fwinfo.number" class="value" v-if="fwinfo">{{fwinfo.version+'.'+fwinfo.number}}</div>
              </div>
              <div class="table-row">
                <div class="title">{{$t('overview.temperature')}} </div>
                <div :title="getTempMsg(sensorStatus)" class="value" :class="[ (sensorStatus && (sensorStatus.SwitchTemp > maxTemp || sensorStatus.SwitchTemp < minTemp)) ? 'warning-msg' : '']">{{tempMsg}}</div>
              </div>
              <div class="table-row" v-if="showFan" v-for="(item, idx) in fanData" :key="idx">
                <div class="title">{{getFanTitle(item, idx)}}</div>
                <div :title="item.val" class="value" >{{item.val}} RPM</div>
              </div>
              <div class="table-row" v-if="sensorStatus && sensorStatus.PowerInfo && sensorStatus.PowerInfo.length > 0">
                <div class="title">{{$t('overview.activePower')}} </div>
                <div :title="activePower" class="value active-power" @click="onActiveClick">{{activePower}}</div>
              </div>
            </div>
            </scrollbar>
            <div class="icon-refresh" @click="onRefresh('sysinfo')"></div>
          </div>
        </div>
      </div>
    <div class="ui-frame" v-if="!isNewUi">
      <div class="bottom_layer no-s" v-if="systemHostInfo && isMultiSpeed">
        <div class="row left">
          <div class="content">
            <loading :mask=true :size="'middle'" :isWhite=true v-if="oneTrafficLoad"/>
            <div class="col-header chart-selection">{{getPortTrafficName}}</div>
            <div class="col-body">
              <div class="traffic-info">
                <span class="title">{{$t('overview.currentTraffic')}}</span>
                <span style="margin-left: 5px;">{{trafficInfo.one.current}} Mbps</span>
              </div>
              <!-- <div class="traffic-info">
                <span class="title">{{$t('overview.totalTraffic')}}</span>
                <span style="margin-left: 5px;">{{trafficInfo.one.total}}</span>
              </div> -->
              <ve-histogram ref="oneG" :data="chartData" :settings="chartConfig.setting" :y-axis="chartConfig.yAxis" :extend="chartConfig.extend" :grid="chartConfig.grid" :colors="chartConfig.color" width="auto" height="215px"></ve-histogram>
            </div>
            <div class="icon-refresh" @click="onRefresh((systemHostInfo.Product.includes('M5216')) ? 'twentyG5' : 'oneG')"></div>
          </div>
        </div>
        <div class="row right">
          <div class="content">
            <loading :mask=true :size="'middle'" :isWhite=true v-if="tenTrafficLoad"/>
            <div class="col-header chart-selection">{{$t('overview.tenGtraffic')}}</div>
            <div class="col-body">
              <div class="traffic-info">
                <span class="title">{{$t('overview.currentTraffic')}}</span>
                <span style="margin-left: 5px;">{{trafficInfo.ten.current}} Mbps</span>
              </div>
              <!-- <div class="traffic-info">
                <span class="title">{{$t('overview.totalTraffic')}}</span>
                <span style="margin-left: 5px;">{{trafficInfo.ten.total}}</span>
              </div> -->
              <ve-histogram ref="tenG" :data="tenGchartData" :settings="chartConfig.setting" :y-axis="chartConfig.tenyAxis" :extend="chartConfig.extend" :grid="chartConfig.grid" :colors="chartConfig.color" width="auto" height="215px"></ve-histogram>
            </div>
            <div class="icon-refresh" @click="onRefresh('tenG')"></div>
          </div>
        </div>
      </div>
      <div class="bottom_layer no-s" v-else >
        <div class="row">
          <div class="content">
            <loading :mask=true :size="'middle'" :isWhite=true v-if="tenTrafficLoad"/>
            <div class="col-header chart-selection">{{$t('overview.tenGtraffic')}}</div>
            <div class="col-body">
              <div class="traffic-info">
                <span class="title">{{$t('overview.currentTraffic')}}</span>
                <span style="margin-left: 5px;">{{trafficInfo.ten.current}} Mbps</span>
              </div>
              <!-- <div class="traffic-info">
                <span class="title">{{$t('overview.totalTraffic')}}</span>
                <span style="margin-left: 5px;">{{trafficInfo.ten.total}}</span>
              </div> -->
              <ve-histogram ref="tenG" :data="tenGchartData" :settings="chartConfig.setting" :y-axis="chartConfig.tenyAxis" :extend="chartConfig.extend" :grid="chartConfig.grid" :colors="chartConfig.color" width="auto" height="215px"></ve-histogram>
            </div>
            <div class="icon-refresh" @click="onRefresh('tenG')"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui-frame" v-else>
      <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
        <div class="content-body" style="height: 100%;">
          <div class="bottom_layer no-s" v-if="systemHostInfo && isMultiSpeed">
            <div class="row left poe-card" style="width:300px;" v-if="systemHostInfo.SupportPoE">
              <div class="content">
                <loading :mask=true :size="'middle'" :isWhite=true v-if="poeStatusLoad"/>
                <div class="col-header chart-selection">{{$t('overview.powerConsumption')}}</div>
                <vue-circle ref="poeCircle" class="left-item no-s" style="width: 100%;text-align: center;" :progress="poeConsumption.TotalPowerConsumption" :size="200" line-cap="round" :fill="consumpitonfill" :empty-fill="emptyFill" :start-angle="300" insert-mode="append" :thickness="5" :show-percent="false" :percentFontSize="percentFontSize" @vue-circle-progress="circleProgress"></vue-circle>
                  <div class="table-row">
                    <div class="title">{{$t('overview.total')}} </div>
                    <span :title="poeConfigPower + $t('poe.simpleWatt')" class="value">{{poeConfigPower}} {{$t('poe.simpleWatt')}}</span>
                  </div>
                  <div class="table-row">
                    <div class="title used">{{$t('overview.inUse')}}</div>
                    <span :title="parseFloat((poeConsumption.TotalPowerConsumption/10).toFixed(1)) + $t('poe.simpleWatt')" class="value">{{parseFloat((poeConsumption.TotalPowerConsumption/10).toFixed(1))}} {{$t('poe.simpleWatt')}}</span>
                  </div>
                  <div class="table-row">
                    <div class="title budget">{{$t('overview.budget')}} </div>
                    <span :title="parseFloat((poeConfigPower - (poeConsumption.TotalPowerConsumption/10)).toFixed(1)) + $t('poe.simpleWatt')" class="value">{{parseFloat((poeConfigPower - (poeConsumption.TotalPowerConsumption/10)).toFixed(1))}} {{$t('poe.simpleWatt')}}</span>
                  </div>
                <div class="icon-refresh" @click="onRefresh('poe')"></div>
              </div>
            </div>
            <div class="row right"  :style="getBottomRightStyle">
              <div class="content">
                <loading :mask=true :size="'middle'" :isWhite=true v-if="buttomRightLoad"/>
                <div class="col-header chart-selection" v-if="systemHostInfo.SupportPoE">
                  <span class="icon-status pr-b-10 col-header-title"></span>
                  <q-select :options-array="chartOptions" :value="selectChart" :isWhite="false" style="width: auto;" :callback="onChangeChart" @change="onChartChange" ></q-select>
                </div>
                <div class="col-header chart-selection" v-else>
                  <div class="icon-status pr-b-10 col-header-title" style="padding-bottom:10px;font-size:16px;font-weight:700;">{{$t('overview.perPortRate')}}</div>
                </div>
                <div class="col-body" v-if="selectChart === 'consumption'" style="height: calc(100% - 50px);">
                  <ve-histogram ref="chart" :data="poeData" :settings="poeConfig.setting" :y-axis="poeConfig.yAxis" :extend="poeConfig.extend" :grid="poeConfig.grid" height="100%"></ve-histogram>
                  <div class="poe-power-status" ref="poeStatus">
                    <span v-for="(item, index) in poePowerList" :key="index" :class="{on: item, off: !item}">{{index+1}}</span>
                  </div>
                  <div class="poe-legend">
                    <div class="on">{{$t('menu.poe')}} {{$t('on')}}</div>
                    <div class="off">{{$t('menu.poe')}} {{$t('off')}}</div>
                  </div>
                </div>
              <div class="col-body" style="height: calc(100% - 50px);" v-else>
                <div style="display:flex;padding-bottom: 20px;">
                  <div class="title" style="line-height:30px;padding-right:10px;">{{$t("poe.choosePort")}}</div>
                  <q-select class="q-select" :value="selectPort" :options-array="menuOptions" @change="onMenuChange" style="width:auto;min-width: 100px;"></q-select>
                </div>
                <div style="height: calc(100% - 50px);">
                  <ve-line ref="rate" :data="rateData" :settings="rateConfig.setting" :y-axis="rateConfig.yAxis" :extend="rateConfig.extend" :grid="rateConfig.grid" :colors="rateConfig.color" height="100%" ></ve-line>
                </div>
                </div>
                  <div class="icon-refresh" @click="onRefresh('bottomright')"></div>
                </div>
              </div>
            </div>
        </div>
    </div>
  </div>
  <popup-confirm name="fail-update-modal" type="w" :dialog-header="$t('warning')" :dialog-message="$t('updatefw.fwFailContent', {error_code: 500})" icon="w" :onlyOk="true" />
</div>
</template>
<script>
import moment from 'moment'
import VeHistogram from 'v-charts/lib/histogram.common'
import VeLine from 'v-charts/lib/line.common'
import echarts from 'echarts'
import FirmwareUpdate from './FirmwareUpdate'
import machine from './module/Machine'
import utility from '../util/utility'
import config from '../config'
import VueCircle from 'vue2-circle-progress'
import qSelect from './module/Select.vue'
import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'
export default {
  name: 'Dashboard',
  components: {
    VeHistogram,
    echarts,
    machine,
    FirmwareUpdate,
    VueCircle,
    qSelect,
    VeLine
  },
  data () {
    return {
      systemInterval: null,
      portTrafficInterval: null,
      ipInterval: null,
      portInterval: null,
      ports: [],
      cpuLoading: 0,
      chartConfig: {
        yAxis: {
          name: this.$t('mbps'),
          nameTextStyle: {
            width: 25,
            fontWeight: 'bold'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#8EA0F9',
              opacity: 0.5
            }
          },
          axisLabel: {
            color: '#000000',
            formatter: this.oneyAxisFormat
          },
          min: 0
        },
        tenyAxis: {
          name: this.$t('mbps'),
          nameTextStyle: {
            width: 25,
            fontWeight: 'bold'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#8EA0F9',
              opacity: 0.5
            }
          },
          axisLabel: {
            color: '#000000',
            formatter: this.tenyAxisFormat
          },
          min: 0
        },
        grid: {
          show: true,
          borderColor: 'none',
          right: 50,
          top: 30,
          bottom: 0
        },
        setting: {
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                [
                  {offset: 0, color: '#5AC0E5'},
                  {offset: 1, color: '#6D7AF2'}
                ]
              )
            }
          }
        },
        extend: {
          series: {
            barWidth: 25,
            cursor: 'default',
            barMinHeight: 2
          },
          xAxis: {
            name: this.$t('overview.potNo'),
            nameLocation: 'end',
            nameGap: 10,
            nameTextStyle: {
              color: '#000000',
              fontWeight: 'bold'
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#8EA0F9',
                type: 'solid',
                width: 2
              }
            },
            axisLabel: {
              color: '#000000'
            }
          },
          legend: {
            show: false
          },
          tooltip: {
            formatter: this.chartTooltipFormatter
          }
        }
      },
      chartData: {
        columns: ['portNum', 'Traffic'],
        rows: []
      },
      tenGchartData: {
        columns: ['portNum', 'Traffic'],
        rows: []
      },
      chartOptions: [
        { value: 'consumption', label: 'overview.perPortPower' },
        { value: 'ratedata', label: 'overview.perPortRate' }
      ],
      poeConfig: {
        grid: {
          show: true,
          backgroundColor: '#ffffff',
          borderColor: 'none',
          containLabel: true,
          right: 90
        },
        setting: {
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                [
                  {offset: 0, color: '#5AC0E5'},
                  {offset: 1, color: '#6D7AF2'}
                ]
              )
            }
          }
        },
        yAxis: {
          name: this.$t('poe.simpleWatt'),
          axisLine: {
            lineStyle: {
              color: '#000000'
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#8EA0F9',
              opacity: 0.5
            }
          },
          axisLabel: {
            formatter: this.yLabelFormatter
          },
          nameTextStyle: {
            color: '#5A52B2',
            fontSize: 13,
            lineHeight: 22
          }
        },
        extend: {
          series: {
            barWidth: 25,
            label: {
              normal: {
                color: '#000000',
                show: true,
                position: 'top',
                fontWeight: 'bold',
                fontSize: 20
              }
            },
            barMinHeight: 1
          },
          xAxis: {
            name: this.$t('overview.portNo'),
            nameLocation: 'end',
            nameGap: 10,
            nameTextStyle: {
              color: '#5A52B2',
              fontSize: 13,
              lineHeight: 22
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#8EA0F9',
                type: 'solid'
              }
            },
            axisLabel: {
              show: false,
              fontWeight: 500,
              fontSize: 14,
              color: '#FFF',
              interval: 0,
              borderRadius: 200,
              inside: true,
              width: 20,
              height: 20,
              lineHeight: 50,
              backgroundColor: '#a8a8a8'
            }
          },
          legend: {
            show: false
          },
          tooltip: {
            formatter: this.chartTooltipPoeFormatter
          }
        }
      },
      poeData: {
        columns: ['portNum', 'Watt'],
        rows: [{'portNum': '', 'Watt': ''}]
      },
      rateConfig: {
        color: ['#F5A623', '#7ED321'],
        grid: {
          show: true,
          borderColor: 'none',
          right: 110,
          top: 50,
          bottom: 0
        },
        setting: {
          labelMap: {
            In: 'Traffic In',
            Out: 'Traffic Out'
          }
        },
        extend: {
          series: {
            symbol: 'none'
          },
          xAxis: {
            name: this.$t('menu.systime'),
            nameLocation: 'end',
            nameGap: 10,
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                type: 'dotted'
              }
            },
            axisLabel: {
              show: true,
              padding: [0, 0, 0, 20],
              interval: function (index, value) {
                if (index === 0 || index === 59) {
                  return true
                } else {
                  return false
                }
              },
              formatter: this.rateYlableFormatter
            },
            nameTextStyle: {
              color: '#8C99FF',
              fontSize: 13,
              lineHeight: 22
            }
          },
          legend: {
            show: true,
            orient: 'vertical',
            selectedMode: false,
            textStyle: {
              color: '#000000'
            },
            right: 0,
            top: 0,
            formatter: this.legendFormatter,
            data: [
              {
                name: 'TrafficIn',
                icon: 'circle'
              }, {
                name: 'TrafficOut',
                icon: 'circle'
              }
            ]
          },
          tooltip: {
            formatter: this.rateTooltipFormatter
          }
        },
        yAxis: {
          name: this.$t('mbps'),
          axisLine: {
            lineStyle: {
              type: 'dashed',
              color: '#8EA0F9',
              opacity: 0.5
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#8EA0F9',
              opacity: 0.5
            }
          },
          nameTextStyle: {
            color: '#8C99FF',
            fontSize: 13,
            lineHeight: 22
          },
          axisLabel: {
            color: '#2F2F2F',
            fontWeight: 500
          }
        }
      },
      rateData: {
        columns: ['Time', 'TrafficIn', 'TrafficOut'],
        rows: []
      },
      ratePorts: [],
      rateIndex: 0,
      selectChart: 'ratedata',
      systemStatus: null,
      ipAddress: null,
      isShowLoading: false,
      preData: { first: [], second: [] },
      preRate: { first: [], second: [] },
      trafficData: null,
      firstSysInfoLoad: true,
      sysInfoLoad: false,
      portStatusLoad: false,
      oneTrafficLoad: false,
      tenTrafficLoad: false,
      buttomRightLoad: false,
      trafficInfo: {
        'one': {'total': '0 GB', 'current': 0},
        'ten': {'total': 0, 'current': 0}
      },
      menuList: config.menu,
      fanData: [],
      showFan: false,
      fanRpm: false,
      portSpeed: [],
      minNumber: 8,
      isMultiSpeed: true,
      poeConsumption: 0,
      consumpitonfill: {gradient: ['#F5A623']},
      emptyFill: 'rgb(168, 168, 168)',
      percentFontSize: '18px',
      poeInterval: null,
      poeConfigPower: 300,
      poeStatusLoad: false,
      poePowerList: [],
      startTime: null,
      isNewUi: false,
      selectPort: 0,
      menuOptions: [
        { value: 0, label: 'all', isDisabled: false }
      ],
      portList: []
    }
  },
  beforeDestroy () {
    clearInterval(this.systemInterval)
    clearInterval(this.portTrafficInterval)
    clearInterval(this.ipInterval)
    clearInterval(this.portInterval)
    clearInterval(this.poeInterval)
    this.systemInterval = null
    this.portTrafficInterval = null
    this.ipInterval = null
    this.portInterval = null
    this.poeInterval = null
    this.menuOptions = [{ value: 0, label: 'all' }]
  },
  watch: {
    currentUser: {
      handler (value) {
        if (value && value.auth !== undefined) {
          this.showInfo()
          if (!this.systemHostInfo.Product.includes('M2108')) {
            this.getFWcondition()
              .then((result) => {
                if (result.data.result.anomaly) {
                  if (!this.$cookie.get(config.system.cookieShowFwWin) || this.$cookie.get(config.system.cookieShowFwWin) !== 'none') {
                    this.openModal('fail-update-modal')
                    this.$modal.show('fail-update-modal')
                    this.$cookie.set(config.system.cookieShowFwWin, 'none')
                  }
                }
              })
          }
        } else {
          clearInterval(this.systemInterval)
          clearInterval(this.portTrafficInterval)
          clearInterval(this.ipInterval)
          clearInterval(this.portInterval)
          clearInterval(this.poeInterval)
          this.systemInterval = null
          this.portTrafficInterval = null
          this.ipInterval = null
          this.portInterval = null
          this.poeInterval = null
        }
      },
      immediate: true,
      deep: true
    },
    isLogin: function (value) {
      if (!value) {
        clearInterval(this.systemInterval)
        clearInterval(this.portTrafficInterval)
        clearInterval(this.ipInterval)
        clearInterval(this.portInterval)
        clearInterval(this.poeInterval)
        this.systemInterval = null
        this.portTrafficInterval = null
        this.ipInterval = null
        this.portInterval = null
        this.poeInterval = null
      }
    },
    showFullLoading: function (value) {
      if (value) {
        clearInterval(this.systemInterval)
        clearInterval(this.portTrafficInterval)
        clearInterval(this.ipInterval)
        clearInterval(this.portInterval)
        clearInterval(this.poeInterval)
      }
    },
    lang: {
      handler (value) {
        setTimeout(() => {
          if (this.$refs.tenG) {
            this.$refs.tenG.$options.propsData.extend.xAxis.name = this.$t('overview.portNo')
          }
          if (this.$refs.oneG) {
            this.$refs.oneG.$options.propsData.extend.xAxis.name = this.$t('overview.portNo')
          }
          if (this.$refs.rate) {
            this.rateConfig.extend.xAxis.name = this.$t('menu.systime')
          }
          if (this.$refs.poeStatus) {
            this.poeConfig.extend.xAxis.name = this.$t('overview.portNo')
            this.poeConfig.yAxis.name = this.$t('poe.simpleWatt')
          }
          this.setMenuOption()
          this.$forceUpdate()
        }, 200)
      },
      immediate: true
    },
    sensorStatus: {
      handler (value) {
        let tempData = []
        this.fanRpm = false
        if (value) {
          this.firstSysInfoLoad = false
          for (const key in value) {
            if (Object.hasOwnProperty.call(value, key)) {
              if (key === 'MaxFanRpm' || key === 'MinFanRpm') this.fanRpm = true
              const element = value[key]
              if (key.includes('Fan') && element > -1) {
                tempData.push({key: key, val: element})
                this.showFan = true
              }
            }
          }
        }
        this.fanData = (this.fanRpm) ? this.checkFanSpeed(tempData) : tempData
      },
      immediate: true
    },
    fwUpdating: {
      handler (value) {
        if (value) {
          clearInterval(this.systemInterval)
          clearInterval(this.portTrafficInterval)
          clearInterval(this.ipInterval)
          clearInterval(this.portInterval)
          this.systemInterval = null
          this.portTrafficInterval = null
          this.ipInterval = null
          this.portInterval = null
        }
      }
    }
  },
  created: async function () {
    let me = this
    this.minNumber = config.productDiff[this.systemHostInfo.Product].minNumber
    this.isMultiSpeed = config.productDiff[this.systemHostInfo.Product].isMultiSpeed
    window.addEventListener('resize', () => {
      if (this.$refs.oneG) {
        this.$refs.oneG.resize()
      }
    })
    this.poeConfig.extend.xAxis.axisLabel.height = 25
    this.poeConfig.extend.xAxis.axisLabel.width = 25
    this.isNewUi = config.productDiff[this.systemHostInfo.Product].isNewUi
    this.startTime = new Date().getTime()
    this.setRateInitailData()
    if (this.systemHostInfo.SupportPoE) {
      me.selectChart = 'consumption'
      this.getPoeGlobal()
        .then(res => {
          me.poeConfigPower = res.data.result.MaxPower
        })
    }
  },
  methods: {
    ...mapActions([
      'getPortStatus', 'getPortConfigure', 'getLagStatus', 'getVlan', 'getIP4Configure', 'getIP4Status', 'getOobIP4Status', 'getPortResource', 'getSystemSensorStatus', 'getPortResourcebyID', 'getFWcondition', 'getPoeStatus', 'getPoeGlobal'
    ]),
    ...mapMutations(['openModal', 'closeModal']),
    getIcon: function (config) {
      let result = ''
      let data = config.data
      switch (config.type) {
        case 'enable':
          if (data) {
            result = 'icon-btn_close'
          } else {
            result = 'icon-tick'
          }
          break
        case 'connect':
          if (data) {
            result = 'icon-connect'
          } else {
            result = 'icon-disconnect'
          }
          break
      }
      return result
    },
    showInfo: function () {
      this.isShowLoading = true
      let user = this.currentUser
      if (user.authPassed === 1) {
        if (this.systemInterval === null) {
          this.systemInterval = setInterval(() => {
            this.getSysInfo()
          }, 10000)
        }
        if (this.portInterval === null) {
          this.portInterval = setInterval(() => {
            this.getPort()
          }, this.intervalTime)
        }
        this.getIpAddress()
        this.getPort()
        this.getPortTraffic()
      } else {
        this.$log.error('showInfo auth fail>>>>')
      }
    },
    trafficInterval: function () {
      this.getPortResource()
        .then(res => {
          if (res.data && res.data.error_code === 200) {
            let data = (res.data)
            this.trafficData = data
            if (this.isMultiSpeed) {
              this.getOnegTraffic()
            }
            this.getTengTraffic()
            this.getRateData()
            this.isShowLoading = false
            this.oneTrafficLoad = false
          }
        })
    },
    getSysInfo: function () {
      let me = this
      this.getSystemSensorStatus()
        .then((result) => {
          if (result.data.error_code === 200) {
            // me.systemStatus = result.data.result
            // me.tempeture = me.systemStatus.SwitchTemp
            me.sysInfoLoad = false
          }
        }).catch((error) => {
          me.$log.error(error)
          if (me.systemInterval) {
            clearInterval(me.systemInterval)
          }
        })
      this.getIpAddress()
    },
    getPort: function () {
      let me = this
      if (this.systemHostInfo.SupportPoE) {
        let tempChartList = []
        this.rateConfig.extend.xAxis.name = this.$t('menu.systime')
        this.poeConfig.extend.xAxis.name = this.$t('overview.portNo')
        this.poeConfig.yAxis.name = this.$t('poe.simpleWatt')
        this.getPoeStatus().then(res => {
          let result = res.data.result
          me.poeConsumption = result
          me.poeConsumption.TotalPowerConsumption = 0
          result.forEach(element => {
            let datas = {
              'portNum': element.key,
              'Watt': element.val.PowerConsumption / 10
            }
            me.poeConsumption.TotalPowerConsumption += element.val.PowerConsumption
            tempChartList[parseInt(element.key) - 1] = datas
            me.poePowerList[parseInt(element.key) - 1] = (element.val.CurrentState === 'poweredDeviceOn')
          })
          let power = (me.poeConsumption.TotalPowerConsumption / 10) / me.poeConfigPower * 100
          // power = (Math.random() % 10) * 100
          me.poeData.rows = tempChartList
          me.poeStatusLoad = false
          me.$refs.poeCircle.updateProgress(power)
        })
      }
      this.axios.all([this.getPortStatus(), this.getPortConfigure()])
        .then(this.axios.spread(function (status, config) {
          let result = status.data.result
          me.portList = result
          result.forEach((element, idx) => {
            if (element.key === config.data.result[idx].key) {
              result[idx].val['Shutdown'] = config.data.result[idx].val.Shutdown
              result[idx].val['Combo'] = config.data.result[idx].val.Combo
              result[idx].val['MediaType'] = config.data.result[idx].val.MediaType
              me.portSpeed[idx] = element.val.Speed
            }
          })
          setTimeout(() => {
            // F5A623
            result.forEach(item => {
              if (Number(item.key) <= me.portNumber) {
                let number = Number(item.key)
                let imgItem = (me.onlySFPlist.indexOf(number) < 0) ? document.getElementById('ethernet_' + number) : null
                let backgroundImg = (imgItem) ? me.$getElementsByClassName(imgItem, 'unconnected')[0] : null
                let connectImg = (imgItem) ? me.$getElementsByClassName(imgItem, 'symbol_enable')[0] : null
                let unconnectImg = (imgItem) ? me.$getElementsByClassName(imgItem, 'symbol_disable')[0] : null
                let sfpItem = (item.val.Combo || me.onlySFPlist.indexOf(number) > -1) ? document.getElementById('sfp_' + number) : null
                let sfpBackground = (sfpItem) ? me.$getElementsByClassName(sfpItem, 'unconnected')[0] : null
                let sfpConnect = (sfpItem) ? me.$getElementsByClassName(sfpItem, 'symbol_enable')[0] : null
                let sfpUnconnect = (sfpItem) ? me.$getElementsByClassName(sfpItem, 'symbol_disable')[0] : null
                let connect = (item.val.Shutdown) ? 'hidden' : 'visible'
                let unconnected = (item.val.Shutdown) ? 'visible' : 'hidden'
                let tooltipsElement = (imgItem) ? document.getElementById('tooltip_' + number) : null
                let sfptooltipsElement = (sfpItem) ? document.getElementById('tooltip_sfp_' + number) : null
                let speed = utility.bytesToSize(item.val.Speed, 1000).split(' ').join('')
                if (imgItem) {
                  connectImg.style.visibility = connect
                  unconnectImg.style.visibility = unconnected
                  tooltipsElement.lastElementChild.textContent = speed
                  imgItem.onmouseover = function () { tooltipsElement.style.visibility = 'hidden' }
                  imgItem.onmouseout = function () { tooltipsElement.style.visibility = 'hidden' }
                }
                if (sfpItem) {
                  sfpConnect.style.visibility = connect
                  sfpUnconnect.style.visibility = unconnected
                  sfptooltipsElement.lastElementChild.textContent = speed
                  sfpItem.onmouseover = function () { sfptooltipsElement.style.visibility = 'hidden' }
                  sfpItem.onmouseout = function () { sfptooltipsElement.style.visibility = 'hidden' }
                }
                if (!item.val.Link) {
                  if (imgItem) backgroundImg.style.fill = '#DBDDDD'
                  if (sfpItem) sfpBackground.style.fill = '#DBDDDD'
                  if (imgItem) imgItem.onmouseover = function () { tooltipsElement.style.visibility = 'hidden' }
                  if (sfpItem) sfpItem.onmouseover = function () { sfptooltipsElement.style.visibility = 'hidden' }
                } else {
                  if (item.val.Combo) {
                    if (item.val.MediaType === 'fiber') {
                      sfpBackground.style.fill = '#7ED321'
                      backgroundImg.style.fill = '#DBDDDD'
                      sfpItem.onmouseover = function () {
                        me.setTransform('sfp', number, speed)
                        sfptooltipsElement.style.visibility = 'visible'
                      }
                      imgItem.onmouseover = function () { tooltipsElement.style.visibility = 'hidden' }
                    } else if (item.val.MediaType === 'copper') {
                      sfpBackground.style.fill = '#DBDDDD'
                      backgroundImg.style.fill = '#7ED321'
                      sfpItem.onmouseover = function () { sfptooltipsElement.style.visibility = 'hidden' }
                      imgItem.onmouseover = function () {
                        me.setTransform('imgItem', number, speed)
                        tooltipsElement.style.visibility = 'visible'
                      }
                    } else {
                      sfpBackground.style.fill = '#DBDDDD'
                      backgroundImg.style.fill = '#DBDDDD'
                      imgItem.onmouseover = function () { tooltipsElement.style.visibility = 'hidden' }
                      sfpItem.onmouseover = function () { sfptooltipsElement.style.visibility = 'hidden' }
                    }
                  } else if (me.onlySFPlist.indexOf(number) > -1) {
                    sfpBackground.style.fill = '#7ED321'
                    sfpItem.onmouseover = function () {
                      me.setTransform('sfp', number, speed)
                      sfptooltipsElement.style.visibility = 'visible'
                    }
                  } else {
                    backgroundImg.style.fill = '#7ED321'
                    imgItem.onmouseover = function () {
                      tooltipsElement.style.visibility = 'visible'
                      me.setTransform('imgItem', number, speed)
                    }
                  }
                }
                if (me.systemHostInfo.SupportPoE) {
                  let poeCircle = (imgItem) ? me.$getElementsByClassName(imgItem, 'circle_flash')[0] : null
                  if (poeCircle && me.poePowerList[number - 1]) {
                    poeCircle.style.fill = '#F5A623'
                  } else if (poeCircle && !me.poePowerList[number - 1]) {
                    poeCircle.style.fill = 'rgba(255,255,255,.6)'
                  }
                }
              }
            })
            me.portStatusLoad = false
            me.buttomRightLoad = false
            me.$forceUpdate()
          }, 200)
        }))
    },
    getPortTraffic: function () {
      if (this.portTrafficInterval === null) {
        this.portTrafficInterval = setInterval(() => {
          this.trafficInterval()
        }, this.intervalTime)
      }
      this.trafficInterval()
    },
    getIpAddress: function () {
      this.getIP4Configure()
        .then((res) => {
          if (res.data && res.data.error_code === 200 && res.data.result) {
            let data = res.data.result
            data.forEach(element => {
              if (element.key === '1') {
                if (element.val.enableInterface) {
                  this.$store.commit('setOobStatus', false)
                  if (element.val.enableDhcpClient) {
                    this.getInBandIpAddress()
                  } else {
                    this.ipAddress = element.val.ipv4Address
                  }
                } else {
                  this.getOutBandIpAddress()
                  this.$store.commit('setOobStatus', true)
                }
              }
            })
          }
        })
    },
    getInBandIpAddress: function () {
      this.getIP4Configure()
        .then((res) => {
          if (res.data && res.data.error_code === 200) {
            let data = res.data
            if (data.result) {
              data.result.forEach(element => {
                if (element.key === '1') {
                  this.ipAddress = element.val.ipv4Address
                }
              })
            }
          }
        })
    },
    getOutBandIpAddress: function () {
      this.getOobIP4Status()
        .then(res => {
          if (res.data && res.data.error_code === 200) {
            let data = res.data.result
            data.forEach(element => {
              if (element.key === '1') {
                this.ipAddress = element.val.ipv4Address
              }
            })
          }
        })
    },
    getOnegTraffic: function () {
      let me = this
      let data = me.trafficData
      let temp = []
      let sum = {'current': 0, 'total': 0}
      data.result.forEach((element, index) => {
        let number = parseInt(element.key)
        if (number <= me.minNumber) {
          let total = element.val.RxOctets + element.val.TxOctets // 該port總和 (bytes)
          let current = Math.round(total / (me.intervalTime / 1000)) * 8 // bits per second
          let currentRx = Math.round(element.val.RxOctets / (me.intervalTime / 1000)) * 8
          let currentTx = Math.round(element.val.TxOctets / (me.intervalTime / 1000)) * 8
          if (me.preData.second && me.preData.second[number - 1]) {
            let traffic = null
            let now, nowRx, nowTx
            if (me.preData.second[number - 1].Traffic > current) {
              nowRx = Math.abs(me.preData.second[number - 1].RxOctets - me.preData.first[number - 1].RxOctets)
              nowTx = Math.abs(me.preData.second[number - 1].TxOctets - me.preData.first[number - 1].TxOctets)
            } else {
              nowRx = Math.abs(currentRx - me.preData.second[number - 1].RxOctets)
              nowTx = Math.abs(currentTx - me.preData.second[number - 1].TxOctets)
            }
            now = utility.bytesToMGb(now, true)
            nowRx = utility.bytesToMGb(nowRx, true)
            nowTx = utility.bytesToMGb(nowTx, true)
            if (now[0] > me.portSpeed[number - 1] / 1000 * 1024) now[0] = me.portSpeed[number - 1] / 1000 * 1024
            if (nowRx[0] > me.portSpeed[number - 1] / 1000 * 1024) nowRx[0] = me.portSpeed[number - 1] / 1000 * 1024
            if (nowTx[0] > me.portSpeed[number - 1] / 1000 * 1024) nowTx[0] = me.portSpeed[number - 1] / 1000 * 1024
            traffic = (current === 0) ? '0' : (nowRx[0] + nowTx[0])
            temp[index] = {
              'portNum': number,
              'Traffic': Number(traffic).toFixed(2)
            }
          } else {
            temp.push({
              'portNum': number,
              'Traffic': '0'
            })
          }
          me.preData.first[number - 1] = me.preData.second[number - 1]
          me.preData.second[number - 1] = {
            'portNum': number,
            'TxOctets': currentTx,
            'RxOctets': currentRx,
            'Traffic': current
          }
          sum.current = sum.current + Number(temp[index].Traffic)
          // sum.total = sum.total + total
        }
      })
      if (sum.current !== 0) {
        sum.current = Number(sum.current.toFixed(2))
      }
      // sum.total = utility.bytesToMGb(sum.total)
      // sum.total = sum.total[0] + ' ' + (sum.total[1] || 'M') + 'B'
      me.trafficInfo.one = sum
      me.chartData.rows = temp
      me.oneTrafficLoad = false
    },
    getTengTraffic: function () {
      let me = this
      let data = me.trafficData
      let tenTemp = []
      let sum = {'current': 0, 'total': 0}
      data.result.forEach((element, index) => {
        let number = parseInt(element.key)
        if (number > me.minNumber && number <= me.portNumber) {
          let total = element.val.RxOctets + element.val.TxOctets // 該port總和 (bytes)
          let current = Math.round(total / (me.intervalTime / 1000)) * 8 // bits per second
          let currentRx = Math.round(element.val.RxOctets / (me.intervalTime / 1000)) * 8
          let currentTx = Math.round(element.val.TxOctets / (me.intervalTime / 1000)) * 8

          if (me.preData.second && me.preData.second[number - 1]) {
            let traffic = null
            let now, nowRx, nowTx
            if (me.preData.first[number - 1] && me.preData.second[number - 1].Traffic > current) {
              nowRx = Math.abs(me.preData.second[number - 1].RxOctets - me.preData.first[number - 1].RxOctets)
              nowTx = Math.abs(me.preData.second[number - 1].TxOctets - me.preData.first[number - 1].TxOctets)
            } else {
              nowRx = Math.abs(currentRx - me.preData.second[number - 1].RxOctets)
              nowTx = Math.abs(currentTx - me.preData.second[number - 1].TxOctets)
            }
            now = utility.bytesToMGb(now, true)
            nowRx = utility.bytesToMGb(nowRx, true)
            nowTx = utility.bytesToMGb(nowTx, true)
            if (now[0] > me.portSpeed[number - 1] / 1000 * 1024) now[0] = me.portSpeed[number - 1] / 1000 * 1024
            if (nowRx[0] > me.portSpeed[number - 1] / 1000 * 1024) nowRx[0] = me.portSpeed[number - 1] / 1000 * 1024
            if (nowTx[0] > me.portSpeed[number - 1] / 1000 * 1024) nowTx[0] = me.portSpeed[number - 1] / 1000 * 1024
            traffic = (current === 0) ? '0' : (nowRx[0] + nowTx[0])
            tenTemp[index - me.minNumber] = {
              'portNum': number,
              'Traffic': Number(traffic).toFixed(2)
            }
          } else {
            tenTemp.push({
              'portNum': number,
              'Traffic': '0'
            })
          }
          me.preData.first[number - 1] = me.preData.second[number - 1]
          me.preData.second[number - 1] = {
            'portNum': number,
            'TxOctets': currentTx,
            'RxOctets': currentRx,
            'Traffic': current
          }
          sum.current = sum.current + Number(tenTemp[index - me.minNumber].Traffic)
          // sum.total = sum.total + total
        }
      })
      // let isGb = ' Mbps'
      // if (sum.current > 1024) {
      //   sum.current = Math.round(((sum.current / 1024) * 100) / 100)
      //   isGb = ' Gbps'
      // }
      if (sum.current !== 0) {
        sum.current = Number(sum.current.toFixed(2))
      }
      // sum.current += ' Mbps'
      // sum.total = utility.bytesToMGb(sum.total)
      // sum.total = sum.total[0] + ' ' + (sum.total[1] || 'M') + 'B'
      me.trafficInfo.ten = sum
      me.tenGchartData.rows = tenTemp
      me.tenTrafficLoad = false
    },
    getRateData: function () {
      let me = this
      let portStatistic = {}
      let maxSpeed = 0
      if (this.selectPort !== 0) {
        let data = me.trafficData.result[this.selectPort - 1]
        portStatistic = {
          'TxOctets': data.val.TxOctets,
          'RxOctets': data.val.RxOctets,
          'TimeStamp': Math.floor((new Date().getTime() - this.startTime) / 1000)
        }
        let detail = null
        if (me.ratePorts.length === 2) {
          if (portStatistic.TxOctets > me.ratePorts[1].TxOctets && portStatistic.RxOctets > me.ratePorts[1].RxOctets) {
            me.ratePorts[0] = me.ratePorts[1]
            me.ratePorts[1] = portStatistic
            detail = {
              'TrafficOut': utility.bytesToMGb(Math.abs(me.ratePorts[1].TxOctets - me.ratePorts[0].TxOctets) * 8 / (me.intervalTime / 1000), true)[0],
              'TrafficIn': utility.bytesToMGb(Math.abs(me.ratePorts[1].RxOctets - me.ratePorts[0].RxOctets) * 8 / (me.intervalTime / 1000), true)[0],
              'Time': (me.rateIndex++).toString()
            }
          } else {
            detail = {
              'TrafficOut': utility.bytesToMGb(Math.abs(me.ratePorts[1].TxOctets - me.ratePorts[0].TxOctets) * 8 / (me.intervalTime / 1000), true)[0],
              'TrafficIn': utility.bytesToMGb(Math.abs(me.ratePorts[1].RxOctets - me.ratePorts[0].RxOctets) * 8 / (me.intervalTime / 1000), true)[0],
              'Time': (me.rateIndex++).toString()
            }
            me.ratePorts[0] = me.ratePorts[1]
            me.ratePorts[1] = portStatistic
            if (me.selectPort !== 0 && detail) {
              detail.TrafficIn = (detail.TrafficIn > me.portSpeed[me.selectPort - 1] / 1000 * 1024) ? parseInt(me.portSpeed[me.selectPort - 1] / 1000 * 1024) : detail.TrafficIn
              detail.TrafficOut = (detail.TrafficOut > me.portSpeed[me.selectPort - 1] / 1000 * 1024) ? parseInt(me.portSpeed[me.selectPort - 1] / 1000 * 1024) : detail.TrafficOut
            }
            if (me.ratePorts.length >= 2 && detail) {
              me.rateData.rows.push(detail)
              me.rateData.rows.shift()
            }
          }
        } else {
          me.ratePorts.push(portStatistic)
        }
        if (me.selectPort !== 0 && detail) {
          detail.TrafficIn = (detail.TrafficIn > me.portSpeed[me.selectPort - 1] / 1000 * 1024) ? parseInt(me.portSpeed[me.selectPort - 1] / 1000 * 1024) : detail.TrafficIn
          detail.TrafficOut = (detail.TrafficOut > me.portSpeed[me.selectPort - 1] / 1000 * 1024) ? parseInt(me.portSpeed[me.selectPort - 1] / 1000 * 1024) : detail.TrafficOut
        }
        if (me.ratePorts.length >= 2 && detail) {
          me.rateData.rows.push(detail)
          me.rateData.rows.shift()
        }
      } else {
        let tempData = me.trafficData.result
        let txTotal = 0
        let rxTotal = 0
        tempData.forEach((element, index) => {
          let number = parseInt(element.key)
          if (number <= me.portNumber) {
            maxSpeed = (me.portSpeed[number - 1] / 1000 * 1024) * 3 / 8 * 1024 * 1024
            me.preRate.first[number - 1] = me.preRate.second[number - 1]
            me.preRate.second[number - 1] = {
              'portNum': number,
              'TxOctets': element.val.TxOctets,
              'RxOctets': element.val.RxOctets
            }
            if (me.preRate.first[number - 1]) {
              let nowT, nowR
              let plusT, plusR
              nowT = Math.abs(me.preRate.second[number - 1].TxOctets - me.preRate.first[number - 1].TxOctets)
              nowR = Math.abs(me.preRate.second[number - 1].RxOctets - me.preRate.first[number - 1].RxOctets)
              if (nowT > maxSpeed) {
                plusT = (maxSpeed)
              } else {
                plusT = nowT
              }
              if (nowR > maxSpeed) {
                plusR = maxSpeed
              } else {
                plusR = nowR
              }
              txTotal += plusT
              rxTotal += plusR
            } else {
              txTotal += 0
              rxTotal += 0
            }
            if (this.portList[index] && (!this.portList[index].val.Link || (element.val.TxOctets === 0 && element.val.RxOctets === 0))) {
              this.menuOptions[index + 1].isDisabled = true
            } else {
              // this.getDisable(number, 'enable')
              this.menuOptions[index + 1].isDisabled = false
            }
          }
        })
        let detail = null
        detail = {
          'TrafficOut': utility.bytesToMGb(txTotal * 8 / (me.intervalTime / 1000), true)[0],
          'TrafficIn': utility.bytesToMGb(rxTotal * 8 / (me.intervalTime / 1000), true)[0],
          'Time': (me.rateIndex++).toString()
        }
        me.rateData.rows.push(detail)
        me.rateData.rows.shift()
      }
    },
    yLabelFormatter: function (value, index) {
      let result = parseFloat(value)
      result = result.toFixed(1)
      return result
    },
    axisLabelFormatter (value) {
      if (parseInt(value) > 10) return 'padding: [5,5,5,5]'
      return 'padding: [5,8,8,5]'
    },
    chartTooltipFormatter: function (params) {
      let value = (parseFloat(params[0].value) === 0) ? 0 : params[0].value
      return this.$t('overview.portNo') + ' ' + params[0].axisValueLabel + '<br/>' + value + ' ' + this.$t('mbps')
    },
    chartTooltipPoeFormatter: function (params) {
      let value = (parseFloat(params[0].value) === 0) ? 0 : params[0].value
      return this.$t('overview.portNo') + ' ' + params[0].axisValueLabel + '<br/>' + value + ' ' + this.$t('poe.simpleWatt')
    },
    oneyAxisFormat: function (params) {
      if (parseFloat(this.trafficInfo.one.current) === 0) {
        if (params === 1 || params === 0) {
          return params
        }
      } else {
        return params
      }
    },
    tenyAxisFormat: function (params) {
      if (parseFloat(this.trafficInfo.ten.current) === 0) {
        if (params === 1 || params === 0) {
          return params
        }
      } else {
        return params
      }
    },
    onRefresh: function (type) {
      if (type === 'sysinfo') {
        this.sysInfoLoad = true
        this.getSysInfo()
      } else if (type === 'portstatus') {
        this.portStatusLoad = true
        this.getPort()
      } else if (type === 'poe') {
        this.poeStatusLoad = true
        this.poeConsumption.TotalPowerConsumption = 0
        this.getPort()
      } else if (type === 'bottomright') {
        this.buttomRightLoad = true
        this.setRateInitailData()
        this.startTime = new Date().getTime()
        this.getPort()
      } else if (type === 'oneG') {
        this.oneTrafficLoad = true
        if (this.portTrafficInterval) {
          clearInterval(this.portTrafficInterval)
          this.portTrafficInterval = null
          this.preData.second.forEach((element) => {
            let number = parseInt(element.key)
            if (number < 9) {
              this.preData.first[number - 1].Traffic = '0'
              this.preData.second[number - 1].Traffic = '0'
            }
          })
          this.chartData.rows.forEach((element, index) => {
            if (index < 9) {
              this.chartData.rows[index].Traffic = '0'
            }
          })
          this.trafficInfo.one = {'total': '0 GB', 'current': 0}
          setTimeout(() => {
            this.oneTrafficLoad = false
            this.$forceUpdate()
          }, 1000)
          setTimeout(() => {
            this.getPortTraffic()
          }, 2000)
        }
      } else if (type === 'twentyG5') {
        this.oneTrafficLoad = true
        if (this.portTrafficInterval) {
          clearInterval(this.portTrafficInterval)
          this.portTrafficInterval = null
          this.preData.second.forEach((element) => {
            let number = parseInt(element.key)
            if (number < 17) {
              this.preData.first[number - 1].Traffic = '0'
              this.preData.second[number - 1].Traffic = '0'
            }
          })
          this.chartData.rows.forEach((element, index) => {
            if (index < 17) {
              this.chartData.rows[index].Traffic = '0'
            }
          })
          this.trafficInfo.one = {'total': '0 GB', 'current': 0}
          setTimeout(() => {
            this.oneTrafficLoad = false
            this.$forceUpdate()
          }, 1000)
          setTimeout(() => {
            this.getPortTraffic()
          }, 2000)
        }
      } else {
        this.tenTrafficLoad = true
        if (this.portTrafficInterval) {
          clearInterval(this.portTrafficInterval)
          this.portTrafficInterval = null
          this.preData.second.forEach((element) => {
            let number = parseInt(element.key)
            if (number > this.minNumber) {
              this.preData.first[number - 1].Traffic = '0'
              this.preData.second[number - 1].Traffic = '0'
            }
          })
          this.tenGchartData.rows.forEach((element, index) => {
            this.tenGchartData.rows[index].Traffic = '0'
          })
          this.trafficInfo.ten = {'total': '0 GB', 'current': 0}
          setTimeout(() => {
            this.tenTrafficLoad = false
            this.$forceUpdate()
          }, 1000)
          setTimeout(() => {
            this.getPortTraffic()
          }, 2000)
        }
      }
    },
    onActiveClick: function () {
      this.$router.push({
        name: 'sysinformation'
      })
      this.$store.commit('updateMenu', this.menuList['SYSMANAGEMENT'].submenu['SYSTEMINFO'])
      setTimeout(() => {
        this.$router.push({
          name: 'sysinformation'
        })
        this.$store.commit('updateSubMenu', this.menuList['SYSMANAGEMENT'].submenu['SYSTEMINFO'].submenu['sysinformation'])
      }, 100)
    },
    getFanTitle: function (data, idx) {
      let title = ''
      if (this.fanData.length > 1) {
        title = this.$t('overview.multifanSpeed', idx + 1)
      } else {
        title = this.$t('overview.fanSpeed', null)
      }
      return title
    },
    checkFanSpeed: function (data) {
      let max = 0
      let min = 0
      let speed = []
      let result = true
      data.forEach(element => {
        if (element.key === 'MaxFanRpm') max = element.val
        if (element.key === 'MinFanRpm') min = element.val
        if (element.key.includes('Speed')) speed.push({ val: element.val })
      })
      speed.forEach(element => {
        if (element.val > max || element.val < min) result = false
      })
      return (result) ? speed : this.fanData
    },
    getTempMsg (data) {
      if (data && data.showTemp) return data.SwitchTemp + '°C'
      return this.tempMsg
    },
    setTransform (type, id, speed) {
      let tips = (type === 'sfp') ? 'tooltip_sfp_' : 'tooltip_'
      if (document.getElementById(tips + id).firstElementChild.getBoundingClientRect().width < 40) {
        let d = document.getElementById(tips + id).firstElementChild.getAttribute('d')
        d = d.split(/(?=[MH])/)
        d = d[0].substring(1)
        d = d.split(' ')
        let txt = document.getElementById(tips + id).lastElementChild
        let x = parseFloat(d[0]) - 15
        let y = parseFloat(d[1]) + 7
        switch (speed) {
          case '10M':
          case '10G':
          case '2.5G':
            break
          case '100M':
            x = x - 2
            break
          case '1G':
          case '5G':
            x = x + 2
            break
        }
        txt.removeAttribute('transform')
        txt.setAttribute('x', x)
        txt.setAttribute('y', y)
      } else {
        let d = document.getElementById(tips + id).firstElementChild.getAttribute('d')
        d = d.split(/(?=[MH])/)
        d = d[0].substring(1)
        d = d.split(' ')
        let txt = document.getElementById(tips + id).lastElementChild
        let x = parseFloat(d[0]) - 19
        let y = parseFloat(d[1]) + 9
        switch (speed) {
          case '10M':
          case '10G':
            break
          case '100M':
            x = x - 2
            break
          case '1G':
          case '5G':
            x = x + 2
            break
          case '2.5G':
            x = x - 1
            break
        }
        txt.removeAttribute('transform')
        txt.setAttribute('x', x)
        txt.setAttribute('y', y)
      }
    },
    circleProgress: function (event, progress, stepValue) {
      let value = (parseFloat((this.poeConsumption.TotalPowerConsumption / 10).toFixed(1))) ? parseFloat((this.poeConsumption.TotalPowerConsumption / 10).toFixed(1)) : 0
      let parentCladdName = event.target.parentNode
      if (parentCladdName.parentNode.className.indexOf('poe-card') > -1) {
        let textElement = this.$getElementsByClassName(this.$refs.poeCircle.$el, 'percent-text')[0]
        textElement.innerText = this.$t('overview.circelUsed') + '\n' + value + 'W'
      } else if (event.target.parentNode.className.indexOf('progress-circle') > -1) {
        let textElement = this.$getElementsByClassName(this.$refs.update.$el, 'percent-text')[0]
        textElement.innerText = Math.round(stepValue) + '%'
      }
    },
    onChartChange: function (value) {
      if (this.selectChart !== value) {
        this.selectChart = value
        this.onChangeChart()
      }
    },
    onChangeChart () {
      this.startTime = new Date().getTime()
      this.setRateInitailData()
    },
    setRateInitailData: function () {
      this.rateIndex = 0
      this.rateData.rows = []
      this.ratePorts = []
      for (var index = 0; index < 60; index++) {
        setTimeout(() => {
          this.rateData.rows.push({
            'Time': (this.rateIndex++).toString(), 'TrafficIn': 0, 'TrafficOut': 0
          })
        }, 300)
      }
    },
    rateYlableFormatter: function (value, index) {
      if (index === 0) {
        return ' ' + this.$t('minAgo')
      } else if (index === 59) {
        return this.$t('now')
      }
    },
    rateTooltipFormatter: function (params) {
      let Tin = params[0].marker + ' ' + this.$t('overview.trafficIn') + ': ' + params[0].data[1].toFixed(2) + ' Mbps'
      let Tout = params[1].marker + ' ' + this.$t('overview.trafficOut') + ': ' + params[1].data[1].toFixed(2) + ' Mbps'
      return Tin + '<br>' + Tout
    },
    legendFormatter: function (name) {
      let result = ''
      if (name === 'TrafficIn') {
        result = this.$t('overview.trafficIn')
      } else {
        result = this.$t('overview.trafficOut')
      }
      return result
    },
    onMenuChange: function (value) {
      this.selectPort = value
      this.setRateInitailData()
      this.startTime = new Date().getTime()
    },
    setMenuOption: function () {
      this.menuOptions = [{ value: 0, label: 'all', isDisabled: false }]
      for (let port = 1; port <= this.portNumber; port++) {
        let disabled = false
        let title = ''
        this.menuOptions.push({
          value: '' + port,
          label: port,
          isDisabled: disabled,
          title: title
        })
      }
      this.$log.debug(this.menuOptions)
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.lang,
      portNumber: state => state.module.portNum,
      fwinfo: state => state.module.fwinfo,
      sysBoard: state => state.module.sysBoard,
      systemHostInfo: state => state.module.systemHostInfo,
      showInfoTips: state => state.app.showInfoTips,
      showFullLoading: state => state.module.showFullLoading,
      currentUser: state => state.module.currentUser,
      sensorStatus: state => state.module.sensorStatus,
      intervalTime: state => state.app.intervalTime,
      fwUpdating: state => state.module.fwUpdating
    }),
    displayDateTime: function () {
      let displayTime = ''
      if (this.systemTime) {
        displayTime = moment(this.systemTime.SystemCurTime).format(this.systemTime.SystemCurTimeFormat)
      } else {
        displayTime = 'unknow'
      }
      return displayTime
    },
    ipAddressMag: function () {
      let result = this.$t('overview.loading')
      if (this.ipAddress) {
        result = this.ipAddress
      }
      return result
    },
    tempMsg: function () {
      let temperature = (this.sensorStatus) ? this.sensorStatus.SwitchTemp : null
      let tempMax = (this.sensorStatus) ? this.sensorStatus.MaxSwitchTemp : 1000
      let tempMin = (this.sensorStatus) ? this.sensorStatus.MinSwitchTemp : null
      let strings = '--'
      if (temperature) {
        if (temperature > tempMax) {
          strings = this.$t('overview.abnormal')
        } else if (temperature < tempMin) {
          strings = this.$t('overview.abnormal')
        } else {
          strings = this.$t('overview.normal')
        }
      }
      return strings
    },
    maxTemp: function () {
      let result = 1000
      if (this.sensorStatus) {
        result = this.sensorStatus.MaxSwitchTemp
        return result
      }
      return result
    },
    minTemp: function () {
      let result = -1000
      if (this.sensorStatus && this.sensorStatus.MinSwitchTemp) {
        result = this.sensorStatus.MinSwitchTemp
        return result
      }
      return result
    },
    activePower: function () {
      let result = '--'
      this.sensorStatus.PowerInfo.forEach((item, index) => {
        if (item.PowerSource === 'Active') {
          result = this.$t('overview.power', index + 1)
        }
      })
      return result
    },
    onlySFPlist: function () {
      return config.productDiff[this.systemHostInfo.Product].sfpPort
    },
    getPortTrafficName: function () {
      let speed1 = config.productDiff[this.systemHostInfo.Product].speed1[1]
      switch (speed1) {
        case 1:
          return this.$t('overview.oneGtraffic')
        case 2.5:
          return this.$t('overview.twoG5traffic')
        case 10:
          return this.$t('overview.twentyG5traffic')
      }
    },
    getBottomRightStyle () {
      if (this.systemHostInfo.SupportPoE) {
        return 'width:calc(100% - 310px);max-width:calc(100% - 310px);'
      }
      return 'width:100%;max-width:100%;margin-left:0px;'
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
@import '../assets/scss/common.scss';

.dashboard {
  color: #000000;
  position: relative;
  .content-body {
    overflow-y: auto;
    background: #f2f2f2;
  }
  .col-header {
    user-select: none;
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
  }
  .row {
    margin-left: initial;
    margin-right: initial;
    >.content {
      background: #ffffff;
      border-radius: 4px;
      padding: 10px 20px;
      height: 100%;
      position: relative;
      >.col-body {
        line-height: 14px;
      }
      >.icon-refresh {
        position: absolute;
        cursor: pointer;
        right: 10px;
        top: 10px;
        &::before:active {
          color: #6D6D6D;
        }
        &:hover {
          color: #BABABA;
        }
      }
    }
  }
  .top_layer {
    top: 0;
    margin-bottom: 10px;
    display: -webkit-flex;
    display: flex;
    height: 190px;
    background: #f2f2f2;
    >.row.left {
      margin-right: 10px;
      width: 600px;
      flex: none;
      .col-body {
        margin-top: 5px;
        >.title {
          width: auto;
          display: inline-block;
        }
      }
      .legend {
        position: absolute;
        bottom: 0px;
        right: 0px;
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap-reverse;
        align-items: center;
        padding-right: 10px;
        padding-bottom: 5px;
        .link, .nolink, .loop, .tenG-link, .power {
          &::before {
            content: "";
            width: 14px;
            height: 14px;
            margin: 0px 5px 1px 10px;
            margin-bottom: 1px;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            display: inline-block;
          }
        }
        .link::before {
          background-color: #7ED321;
        }
        .nolink::before {
          background-color: #DBDDDD;
        }
        .loop::before {
          background-color: #F54848;
        }
        .tenG-link::before {
          background-color: #32CCFF;
        }.power::before {
          background-color: #F5A623;
        }
        .enable-status {
          display: inline-block;
        }
        .icon-tick, .icon-btn_close, .link, .nolink {
          display: inline-block;
      }
      }
    }
    >.row.right {
      flex: 1;
      >.content {
      .scrollbar-body {
        height: calc(100% - 17px);
      }
        .col-body {
          .table-row {
            line-height: 14px;
            margin-bottom: 10px;
            .title {
              display: inline-block;
              font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
            }
            .value {
              display: inline-block;
              font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
              &.active-power {
                text-decoration: underline;
                &:hover {
                  cursor: pointer;
                }
              }
            }
          }
        }
      }

    }
  }
  .bottom_layer {
    height: 100%; // calc(100% - 200px)
    min-height: 340px;
    display: -webkit-flex;
    display: flex;
    font-size: 14px;
    background: #f2f2f2;
    .ve-histogram {
      margin-top: 25px;
    }
    .traffic-info {
      margin-bottom: 5px;
    }
    >.row.left {
      max-width: 60%;
      .content {
        .col-body {
          position: relative;
          margin-top: 15px;
          .title {
            font-family: 'Roboto-M';
            margin-bottom: 5px;
          }
        }
      }
    }
    .poe-card {
      .content {
        .left-item {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
          margin-bottom: 20px;
        }
        .table-row {
          line-height: 14px;
          margin-top: 10px;
          margin-left: 20px;
          .title {
            color: #5a52b2;
            font-weight: 500;
            margin-right: 10px;
            display: inline-block;
            font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
          }
          .value {
            display: inline-block;
            font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
            &.active-power {
              text-decoration: underline;
              &:hover {
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    .poe-legend {
      bottom: 50px;
      position: relative;
      >div {
        display: flex;
        justify-content: flex-end;
        &.on::before, &.off::before {
          content: "";
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          margin-right: 10px;
          position: relative;
          top: 5px;
        }
        &.on::before {
          background: #7ED321;
        }
        &.off::before {
          background: #9EA4AE;
        }
      }
    }
    .poe-power-status {
      position: absolute;
      width: calc(100% - 165px);
      display: flex;
      margin-left: 35px;
      justify-content: space-around;
      bottom: 30px;
      >span {
        text-align: center;
        color: #FFF;
        font-weight: bolder;
        vertical-align: middle;
        font-size: 16px;
        line-height: 18px;
        &.on, &.off {
          content: "";
          display: inline-block;
          width: 22.5px;
          height: 22.5px;
          border-radius: 50%;
          position: relative;
        }
        &.on {
          background: #7ED321;
        }
        &.off {
          background: #9EA4AE;
        }
      }
    }
    .row.right {
      margin-left: 10px;
      max-width: 40%;
      .col-body {
        margin-top: 15px;
      }
      .chart-selection {
        position: relative;
        left: 5px;
        top: 5px;
        .q-select {
          vertical-align: bottom;
          border: none !important;
          background: inherit !important;
          color: #000000;
          outline: none;
          width: initial;
          /deep/  .display-label {
            font-size: 15px;
          }
        }
      }
    }
    .row {
      width: 100%;
    }
  }
  .device-img {
    &.Link {
      svg {
        background: #7ED321;
        padding: 2px;
      }
    }
  }
  .ui-frame {
    height: calc(100% - 200px);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue